import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import SliderDatetime from '../components/SliderDatetime'
import { makeGetEpochtimes } from '../selectors/epochtimesSelector'
import { makeGetMarks } from '../selectors/marksSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { convertDatetimeToEpochtime } from '../utility/convertDatetimesToEpochtimes'
import TimestampActions from '../redux/timestampRedux'
import { withErrorBoundary } from '../errors/ErrorBoundary'

class SliderDatetimeContainer extends PureComponent {
  handleChange = value => {
    const { actions, layerName, datetimeId } = this.props

    actions.setAdvancedTimeRequested(value, datetimeId || layerName)
  }

  handlePrevious = () => {
    const { epochtimes, epochtime, actions, layerName, datetimeId } = this.props

    const newEpochtime = epochtimes[epochtimes.indexOf(epochtime) - 1]

    newEpochtime && actions.setAdvancedTimeRequested(newEpochtime, datetimeId || layerName)
  }

  handleNext = () => {
    const { epochtimes, epochtime, actions, layerName, datetimeId } = this.props

    const newEpochtime = epochtimes[epochtimes.indexOf(epochtime) + 1]

    newEpochtime && actions.setAdvancedTimeRequested(newEpochtime, datetimeId || layerName)
  }

  handleToggleFirst = () => {
    const { epochtimes, epochtime, actions, layerName, datetimeId } = this.props

    const newEpochtime = epochtimes[0]

    newEpochtime && actions.layerTimeToggled(datetimeId || layerName, newEpochtime)
  }

  render () {
    const { epochtimes, marks, epochtime } = this.props

    return (
      <SliderDatetime
        {...this.props}
        handleChange={this.handleChange}
        handlePrevious={this.handlePrevious}
        handleNext={this.handleNext}
      />
    )
  }
}

const makeMapStateToProps = () => {
  const getEpochtimes = makeGetEpochtimes()
  const getMarks = makeGetMarks()
  const getDatetime = makeGetDatetime()

  const mapStateToProps = (state, props) => {
    const { layerName, datetimeId } = props
    const datetimeName = datetimeId || layerName
    const epochtimes = getEpochtimes(state, datetimeName)

    return {
      epochtimes,
      marks: getMarks(state, epochtimes),
      epochtime: getDatetime(state, datetimeName, convertDatetimeToEpochtime)
    }
  }

  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      setAdvancedTimeRequested: (timestamp, layerName) =>
        dispatch(
          TimestampActions.setAdvancedTimeRequested(timestamp, layerName)
        ),
      toggleAdvancedTimeRequested: (timestamp, layerName) =>
        dispatch(
          TimestampActions.layerTimeToggled(layerName, timestamp)
        )
    }
  }
}

export default withErrorBoundary(connect(makeMapStateToProps, mapDispatchToProps)(
  SliderDatetimeContainer
))



// WEBPACK FOOTER //
// ./src/containers/SliderDatetimeContainer.js